import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { FiltersUiVersion } from '@zaoblako/web/core/types/filters-ui-version.type';
import { NomenclatureTreeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-tree-find.dto';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';

@Component({
  standalone: true,
  selector: 'crm-nomenclature-multi-select',
  templateUrl: './nomenclature-multi-select.component.html',
  imports: [CommonModule, MultiSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NomenclatureMultiSelectComponent {
  @Input() public filtersUiVersion: FiltersUiVersion = 'v2';

  @Input() public nomenclatures: NomenclatureTreeFindInterface[] = [];
  @Input() public selectedNomenclatures: NomenclatureTreeFindInterface[] = [];
  @Output() public selectedNomenclaturesChange = new EventEmitter<NomenclatureTreeFindInterface[]>();

  @Output() public openedChange = new EventEmitter<boolean>();
  @Output() public panelShow = new EventEmitter<void>();
  @Output() public panelHide = new EventEmitter<void>();

  @Input() public class = '';
  @Input() public styleClass: string;
  @Input() public appendTo = '';
  @Input() public scrollHeight = '300px';
  @Input() public disabled = false;
  @Input() public groupsDisabled = false;
  @Input() public sort: string;
  @Input() public showClear = true;
  @Input() public isError = false;
  @Input() public isFloatLabel = true;
  @Input() public label: string;
  @Input() public placeholder = 'Выберите номенклатуру';
  @Input() public display: 'comma' | 'chip' = 'chip';
  @Input() public loading: boolean;
  @Input() public panelStyleClass: string;
}
